import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    const swiper = new Swiper('.booom-logo-slider__swiper', {
        modules: [Autoplay],
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        slidesPerView: 'auto',
        spaceBetween: 16,
        centeredSlides: true,
        breakpoints: {
            768: {
                spaceBetween: 32,
            },
        },
    });
});